import { ListItem, ListItemIcon, Paper } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Popper from "@material-ui/core/Popper";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AllInboxIcon from "@material-ui/icons/AllInbox";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import FaceIcon from "@material-ui/icons/Face";
import LocalPharmacyIcon from '@material-ui/icons/LocalPharmacy';
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  getSessionData
} from "../../base/helper/baseHelper";
import { signOut } from "../../signin/helper/signInHelper";

const drawerWidth = 275;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    color: "primary",
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
    color: "rgba(0, 0, 0, 0.7);",
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "auto",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  AccountPopUp: {
    backgroundColor: "rgba(255,255,255,0.8)",
    // backgroundColor: "red",
    border: "green",
    backdropFilter: "blur(6px)",
  },
  options : {
    color: "rgba(255,255,255,0.7)",
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
  },
}));

const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge);

export default function Profile() {
  const classes = useStyles();

  const [openAccountPopUp, setopenAccountPopUp] = React.useState(false);
  const accountAnchorRef = React.useRef(null);
  const [userId, setUserId] = React.useState("");
  const [showStoreProfile,setShowStoreProfile] = useState(false);
  const [modules, setModules] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverClose = (event) => {
    setAnchorEl(null)
  };

  const open = Boolean(anchorEl);

  const assetManagement = modules?.find(
    (item) => item.modulename === "Asset Management"
  );
  const licenseManagement = modules?.find(
    (item) => item.modulename === "License Management"
  );
  const employeeManagement = modules?.find(
    (item) => item.modulename === "Employee Management"
  );
  const supplierManagement = modules?.find(
    (item) => item.modulename === "Supplier Management"
  );

  useEffect(() => {
    if (sessionStorage.aimsadmintoken) {
      const userModules = JSON.parse(getSessionData({ key: "userModules" }));
      setModules(userModules);
    }
  }, []);

  const handleAccountPopUpToggle = () => {
    setopenAccountPopUp((prevAccountOpen) => !prevAccountOpen);
  };

  const handleAccountPopUpClose = (event) => {
    if (
      accountAnchorRef.current &&
      accountAnchorRef.current.contains(event.target)
    ) {
      return;
    }
    setopenAccountPopUp(false);
    setAnchorEl(null);
  };

  function handleAccountPopUpListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setopenAccountPopUp(false);
    }
  }

  const prevAccountOpen = React.useRef(openAccountPopUp);
  React.useEffect(() => {
    setUserId(sessionStorage.getItem("userId"));
    prevAccountOpen.current = openAccountPopUp;

    const storeData = getSessionData({ key: "store" });

    if(storeData){
      setShowStoreProfile(true);
    }
    else{
      setShowStoreProfile(false);
    }

  }, [userId, openAccountPopUp,setShowStoreProfile]);
  return (
    <React.Fragment>
      <IconButton
        onClick={handleAccountPopUpToggle}
        ref={accountAnchorRef}
        aria-controls={openAccountPopUp ? "menu-list-grow" : undefined}
        aria-haspopup="true"
      >
        <StyledBadge
          overlap="circular"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          variant="dot"
        >
          {showStoreProfile ? (
            <LocalPharmacyIcon alt="Remy Sharp" fontSize="medium"/>
          ) : (
            <Avatar alt="Remy Sharp" />
          )}
          
        </StyledBadge>
        <Popper
          open={openAccountPopUp}
          anchorEl={accountAnchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper className={classes.AccountPopUp}>
                <ClickAwayListener 
                onClickAway={handleAccountPopUpClose}
                >
                  <MenuList
                    autoFocusItem={openAccountPopUp}
                    id="menu-list-grow"
                    onKeyDown={handleAccountPopUpListKeyDown}
                  >
                    <ListItem>
                        <ListItemIcon>
                          <span>Hi, {userId}</span>
                        </ListItemIcon>
                    </ListItem>
                    {showStoreProfile ? (
                      <>
                        <MenuItem
                          onClick={handleAccountPopUpClose}
                          component={Link}
                          to="/myStore"
                        >
                          <ListItemIcon>
                            <LocalPharmacyIcon className="text-center" fontSize="small"/>
                            <span>Pharmacy Profile</span>
                          </ListItemIcon>
                        </MenuItem> 
                        {/* <MenuItem
                          aria-owns={showMenu ? "menu-list-grow" : null}
                          aria-haspopup="true"
                          onMouseEnter={handlePopoverOpen}
                          onMouseOver={handlePopoverStay}
                          onClick={handlePopoverClose}
                        >
                            <ListItemIcon>
                              <Typography>
                                  Options
                              </Typography>
                            </ListItemIcon>
                        </MenuItem> */}
                        </>
                    ) : (
                      <MenuItem
                        onClick={handleAccountPopUpClose}
                        component={Link}
                        to="/myAccount"
                      >
                        <ListItemIcon>
                          <FaceIcon fontSize="small" />
                          <span>My Account</span>
                        </ListItemIcon>
                      </MenuItem>
                    )}
                    <MenuItem
                      onClick={() => {
                        signOut();
                      }}
                      component={Link}
                      to="/signin"
                    >
                      <ListItemIcon>
                        <ExitToAppIcon fontSize="small" />
                        <span>Sign out</span>
                      </ListItemIcon>
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
        <Paper className={classes.AccountPopUp}>
            <Popper
            open={open}
            anchorEl={anchorEl}
            placement="left-start"
            onMouseLeave={handlePopoverClose}
          > 
              <MenuList
              autoFocusItem={openAccountPopUp}
              id="menu-list-grow"
              style={{backgroundColor : "rgba(105,102,100,0.7)"}}
            >
            {assetManagement && 
              <MenuItem
              onClick={handleAccountPopUpClose}
              component={Link}
              to="/assetManagement"
              >
                <ListItemIcon>
                  <ShoppingCartIcon className="text-center" fontSize="small"/>
                  <span classname={classes.options} style={{color: "rgba(255,255,255,0.9)"}}>Asset Management</span>
                </ListItemIcon>
              </MenuItem> 
            }
            {licenseManagement && 
              <MenuItem
              onClick={handleAccountPopUpClose}
              component={Link}
              to="/ancillary/licenseManagement"
            >                      
                <ListItemIcon>
                  <AllInboxIcon className="text-center" fontSize="small"/>
                  <span classname={classes.options} style={{color: "rgba(255,255,255,0.9)"}}>License Management</span>
                </ListItemIcon>
                </MenuItem> 
            }
            {employeeManagement && 
              <MenuItem
                onClick={handleAccountPopUpClose}
                component={Link}
                to="/employeeManagement"
              >                        
                <ListItemIcon>
                  <PersonAddIcon className="text-center" fontSize="small"/>
                  <span classname={classes.options} style={{color: "rgba(255,255,255,0.9)"}}>Manage Employee</span>
                </ListItemIcon>
              </MenuItem>  
            }
            {supplierManagement && 
              <MenuItem
                onClick={handleAccountPopUpClose}
                component={Link}
                to="/ancillary/supplierManagement"
              >      
                <ListItemIcon>                    
                  <LocalShippingIcon className="text-center" fontSize="small"/>
                  <span classname={classes.options} style={{color: "rgba(255,255,255,0.9)"}}>Supplier</span>
                </ListItemIcon>
              </MenuItem>
            }                                                                    
            </MenuList>
        </Popper>
      </Paper>
      </IconButton>
    </React.Fragment>
  );
}
